




























































import {Vue, Component} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatDate} from "@/utils/formatters";

@Component({})
export default class PlaniranePosete extends mixins(ComponentBaseMixin) {
  plannedVisits = [];
  columns = [];
  storeCategories = [];
  merchandisers = [];
  merchandiser = '';
  isBusySave = false;
  isBusySearch = false;

  tableOptions = {
    sortable: true,
    pagination: true,
      pageSize: 100
  };

  async created() {
    this.columns = [
      {field: 'storeName', title: this.$i18n.t('naziv'), sortable: true},
      {field: 'address', title: this.$i18n.t('adresa')},
      {field: 'city', title: this.$i18n.t('mesto'), sortable: true},
      {field: 'category', title: this.$i18n.t('kat'), sortable: true},
      {
        field: 'lastVisit',
        title: this.$i18n.t('datumPoslednjePosete'),
        sortable: true,
        formatter: formatDate
      },
      {
        field: 'expectedVisit',
        title: this.$i18n.t('datumPlaniranePosete'),
        sortable: true,
        formatter: formatDate
      },
      {field: 'due', title: this.$i18n.t('kasnjenje'), sortable: true},
    ];
    this.axios.get('api/GetStoreCategories').then((result) => {
      this.storeCategories = result.data.map(x => ({
        id: x.id,
        name: x.name,
        daysToRevisit: x.daysToRevisit
      }));
    });

    const {data} = await this.axios.get('api/GetUsers');
    this.merchandisers = data;

    //this.loadPlannedVisits();
  }

  loadPlannedVisits() {
    this.plannedVisits = [];
    let table = $('#scheduledTable');
    table.bootstrapTable('showLoading');
    this.isBusySearch = true;
    this.axios.get(`api/GetLastAndExpectedVisits/${this.merchandiser || ''}`).then((result) => {
      this.plannedVisits = result.data;
    }).catch(e => {
      this.showError('greskaPrilikomUcitavanja');
      table.bootstrapTable('hideLoading');
      this.isBusySearch = false;
    }).finally(() => {
      table.bootstrapTable('hideLoading');
      this.isBusySearch = false;
    })
  }

  async sacuvajInterval() {
    if (this.isBusySave) return;
    try {
      this.isBusySave = true;
      await this.axios.put('api/SaveDaysToRevisit', this.storeCategories);
      this.showInfo('podaciUspesnoSacuvani');
    } catch (e) {
      this.isBusySave = false;
      this.showError('neuspesnoCuvanjePodataka');
    } finally {
      this.isBusySave = false;
    }
  }

  search() {
    this.loadPlannedVisits();
  }
}
